/**
 * Reading the server's options: what the player can do right now. Each option is true, or the reason it can't be
 * done, so the app never works out the rules itself.
 */

/** Null when allowed, otherwise why not. A missing option (the game hasn't loaded them) is not allowed. */
export function optionReason(option) {
  if (option === true) {
    return null;
  }
  return typeof option === 'string' ? option : 'Not available right now.';
}

/** The options for the hand card at `handPosition` under `kind` ('evolve' or 'trainers'). */
const handOption = (options, kind, handPosition) => options && options.getIn([kind, String(handPosition)]);

/** Which of your Pokémon the evolution card at `handPosition` can go on: 'active' and bench positions. */
export function evolveTargets(options, handPosition) {
  const option = handOption(options, 'evolve', handPosition);
  return option && typeof option === 'object' ? option.toJS() : [];
}

/**
 * The option for what picks are being made for: a Trainer in the hand (`trainers` by hand position) or a Pokémon
 * Power (`powers` by where the Pokémon is, then move id). True when it picks nothing, a list of each step's targets,
 * or the reason it can't be used.
 *
 * @param {Map|undefined} options
 * @param {Map} source { kind: 'trainer', handPosition } or { kind: 'power', at, moveId }
 */
export function sourceOption(options, source) {
  if (!options || !source) {
    return undefined;
  }
  return source.get('kind') === 'power'
    ? options.getIn(['powers', String(source.get('at')), String(source.get('moveId'))])
    : options.getIn(['trainers', String(source.get('handPosition'))]);
}

/**
 * What step `index` can pick, from an option: 'active' and bench positions on a side, card positions in the hand or
 * discard pile, or energy types. Empty when the option is a reason or picks nothing.
 */
export function stepTargets(option, index) {
  return option && typeof option === 'object' && option.get(index) ? option.get(index).toJS() : [];
}

/** Why the hand card can't be played, or null. */
export function handReason(options, kind, handPosition) {
  const option = handOption(options, kind, handPosition);
  return typeof option === 'string' ? option : null;
}

/** A Trainer that is played without picking a Pokémon (Bill) and can be played now. */
export function handPlayable(options, kind, handPosition) {
  return handOption(options, kind, handPosition) === true;
}

export const evolveReason = (options, handPosition) => handReason(options, 'evolve', handPosition);
